import { AxiosResponse } from "axios";
import { request } from "@utils";
import { PaginatedContracts, ContractDetail } from "@types";

export const getAllContracts = (
  page: number,
  locationId?: string,
  origin?: string,
  status?: string,
  sortField?: string,
  sortOrder?: string,
): Promise<AxiosResponse<PaginatedContracts>> => {
  const req = request();
  const params = new URLSearchParams({ page: String(page), limit: "50" });
  if (locationId) params.set("locationId", locationId);
  if (origin) params.set("origin", origin);
  if (status) params.set("status", status);
  if (sortField) params.set("sortField", sortField);
  if (sortOrder) params.set("sortOrder", sortOrder);
  return req.get(`/api/v1/contracts?${params.toString()}`);
};

export const getContractById = (
  contractId: string,
): Promise<AxiosResponse<{ success: boolean; data: ContractDetail }>> => {
  const req = request();
  return req.get(`/api/v1/contracts/${contractId}`);
};
